export enum PromotionDiscountTypeEnum {
  BAHT = 'BAHT',
  PERCENTAGE = 'PERCENTAGE',
}
